import React from 'react';
import './Syles/TabContainer.scss';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Forward from './Forward';
import Usability from './Usability';
import Prototyping from './Prototyping';
const TabContainer=()=>{
    return(
        <div className="tabs-home">
            <h1>Your design process, in one place</h1>
            <p className="sub">Wireframe, design and prototype fast with our intuitive design and prototyping tools. Instantly generate design specs and connect integrations that power up your workflow. From low to high-fidelity, HostDesign supports you every step of the way.</p>
            <Tabs>
                <TabList>
                    <Tab>
                        Seamless Collaboration
                    </Tab>
                    <Tab>
                        Instant Wireframing
                    </Tab>
                    <Tab>
                        Easy Pototyping
                    </Tab>
                    <Tab>
                        Usability Testing
                    </Tab>
                </TabList>
                <TabPanel>
                    <Forward title="Seamless Collaboration" desc="With Hoststyle you can share your design and gather feedback easy — right on the design itself."/>
                </TabPanel>
                <TabPanel>
                    <Usability />
                </TabPanel>
                <TabPanel>
                    <Prototyping title="Easy Prototyping" desc="Transform your design mockups into interactive web or app prototypes without writing a single line of code." btn="Learn More"/>
                </TabPanel>
                <TabPanel>
                    <Usability />
                </TabPanel>
            </Tabs>
        </div>
    )
};
export default TabContainer;